import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ModalName } from "src/app/enums/modal-name";
import { IContact } from "src/app/models/contact/contact";
import { IContactsSearchParams } from "src/app/models/contact/contacts-search-params";
import { IUpdateContactPayload } from "src/app/models/contact/update-contact-payload";
import { ContactService } from "src/app/services/contact.service";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-phone-book",
  templateUrl: "./phone-book.component.html",
  styleUrls: ["./phone-book.component.scss"],
})
export class PhoneBookComponent implements OnInit {
  contacts: IContact[] = [];
  isContactsLoading = true;
  selectedContact: IContact | null = null;
  contactsSearchParams: IContactsSearchParams = {
    pageNumber: "1",
    pageSize: "10",
    searchString: "",
  };

  constructor(
    private readonly _contactService: ContactService,
    private readonly _modalService: ModalService,
    private readonly _router: Router
  ) {}

  getContacts() {
    const contactsSearchParams: IContactsSearchParams = {
      ...this.contactsSearchParams,
      searchString: this.contactsSearchParams.searchString.trim() || undefined,
    };

    if (!contactsSearchParams.searchString) {
      delete contactsSearchParams.searchString;
    }

    this._contactService.getAll(contactsSearchParams).subscribe(contacts => {
      this.contacts = contacts.records;
      this.isContactsLoading = false;
    });
  }

  openCreateContactModal() {
    this._modalService.openModal(ModalName.CreateContact);
  }

  openEditContactModal(contact: IContact) {
    this.selectedContact = contact;
    this._modalService.openModal(ModalName.EditContact);
  }

  openDeleteContactModal(contact: IContact) {
    this.selectedContact = contact;
    this._modalService.openModal(ModalName.DeleteContact);
  }

  createContact(payload: IContact) {
    this._contactService.create(payload).subscribe({
      next: () => this.getContacts(),
    });
  }

  navigateToSendFax(contact: IContact) {
    this._router.navigate(["/faxes/send"], { state: { contact } });
  }

  updateContact(payload: IUpdateContactPayload) {
    this._contactService.update(payload).subscribe({
      next: () => this.getContacts(),
    });
  }

  deleteContact() {
    if (this.selectedContact) {
      this._contactService.delete({ name: this.selectedContact.name }).subscribe({
        next: () => this.getContacts(),
      });
    }
  }

  ngOnInit() {
    this.getContacts();
  }
}
